var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChashier = function SvgChashier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.833 3.667a2.5 2.5 0 0 1 2.5-2.5h9.334a2.5 2.5 0 0 1 2.5 2.5V9.04h-3.334v9.792h-11V3.667Zm10 5.374V2.166h-7.5a1.5 1.5 0 0 0-1.5 1.5v14.167h9V9.042Zm1-1h2.334V3.667a1.5 1.5 0 0 0-1.5-1.5h-.834V8.04Zm-3-.875h-5v-1h5v1Zm-5 3.334h5v-1h-5v1Zm5 3.333h-5v-1h5v1Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.833 3.667a2.5 2.5 0 0 1 2.5-2.5h9.334a2.5 2.5 0 0 1 2.5 2.5V9.04h-3.334v9.792h-11V3.667Zm10 5.374V2.166h-7.5a1.5 1.5 0 0 0-1.5 1.5v14.167h9V9.042Zm1-1h2.334V3.667a1.5 1.5 0 0 0-1.5-1.5h-.834V8.04Zm-3-.875h-5v-1h5v1Zm-5 3.334h5v-1h-5v1Zm5 3.333h-5v-1h5v1Z",
    fill: "#747F88"
  })));
};

export default SvgChashier;